import React from "react";
import ClearLocalStorage from "../features/clearLocalStorage";

export default function ClearLocalStoragePage() {
    return (
        <ClearLocalStorage />
    );
}
